import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SurveyAccomplishPage } from './survey-accomplish';


@NgModule({
  declarations: [
    SurveyAccomplishPage,
  ],
  imports: [
    IonicPageModule.forChild(SurveyAccomplishPage),
  ],
})
export class SurveyAccomplishPageModule {}




// WEBPACK FOOTER //
// ./src/pages/survey-accomplish/survey-accomplish.module.ts